import React from 'react';

import T from 'components/T';

import Panel from '../components/Panels';

const ResourceNotFound = () => (
  <Panel>
    <h4>
      <T value='components.ResourceNotFound.title' />
    </h4>
    <T value='components.ResourceNotFound.text' dangerousHTML />
  </Panel>
);

export default ResourceNotFound;
